module.exports = __webpack_public_path__ + "static/media/DP_Timeless_Piazza_Ind.Blue.a52220f7.png";